import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'
const phoneUtil = PhoneNumberUtil.getInstance()

export const parsePhone = (countryCode = '', phoneCode = '', phoneNumber = ''): string | null => {
  try {
    if (/[a-z]+/i.test(phoneNumber)) {
      return null
    }

    const rawPhone = `${phoneCode}${phoneNumber}`
    const parsedPhone = phoneUtil.parse(rawPhone, countryCode)

    if (!phoneUtil.isValidNumber(parsedPhone)) {
      return null
    }

    const phone = phoneUtil
      .format(parsedPhone, PhoneNumberFormat.INTERNATIONAL)
      .replace(/[^\d+]/gim, '')

    return phone
  } catch (e) {
    return null
  }
}
